import { Link } from "react-router-dom";
import { useAdminData } from "../../admin/AdminDataContext";

function AdminDashboard() {
  const { events, services, testimonials, loading, error } = useAdminData();

  if (loading) return <p className="body-text">Loading admin data...</p>;
  if (error) return <p className="admin-error">Error: {error}</p>;

  return (
    <div>
      <h1 className="display-text" style={{ fontSize: 42, marginBottom: 24 }}>
        Dashboard
      </h1>
      <div className="admin-stat-grid">
        <Link to="/admin/events" className="admin-stat-card">
          <h2>{events.length}</h2>
          <p className="body-text">Events</p>
        </Link>
        <Link to="/admin/services" className="admin-stat-card">
          <h2>{services.length}</h2>
          <p className="body-text">Services</p>
        </Link>
        <Link to="/admin/testimonials" className="admin-stat-card">
          <h2>{testimonials.length}</h2>
          <p className="body-text">Testimonials</p>
        </Link>
      </div>
    </div>
  );
}

export default AdminDashboard;
